export default __webpack_public_path__ + "static/media/A4 large 13.573ecb90.jpg";